import React from "react";
import "../../styles/DocumentViewerModal.css";

const DocumentViewerModal = ({ fileUrl, documentName, onClose }) => {
  if (!fileUrl) return null;

  const isPdf = (() => {
    try {
      const url = new URL(fileUrl);
      const filename = url.searchParams.get("filename")?.toLowerCase();
      return filename?.endsWith(".pdf");
    } catch {
      return false;
    }
  })();

  return (
    <div className="doc-modal-overlay">
      <div className="doc-modal">

        <div className="doc-modal-header">
          <div className="doc-title">
            <span>📄</span>
            <span className="file-name">
              {documentName || "Document"}
            </span>
          </div>

          <button
            type="button"
            className="doc-modal-close"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="doc-modal-body">
          {isPdf ? (
            <embed
              src={fileUrl}
              type="application/pdf"
              className="doc-modal-content"
            />
          ) : (
            <img
              src={fileUrl}
              alt={documentName}
              className="doc-modal-content"
            />
          )}
        </div>

      </div>
    </div>
  );
};

export default DocumentViewerModal;
